import { inUniAppOrApp } from '~/utils/inApp'
import { useLocalePath, useRouter } from '#imports'
import { useUserStore } from '~/store/user'
import { nativeGoLogin } from '@/utils/JSbridge'

export function useBackUrl(href) {
  if (import.meta.server)
    return href
  const query = new URLSearchParams(location.search)

  if (!query.get('backUrl') && !['log-in', 'sign-up', 'forgot'].some(v => location.pathname.includes(v))) {
    query.set('backUrl', location.pathname)
  }

  return `${href}?${query.toString()}`
}

export function useRtl() {
  const { locale } = useI18n()

  const isRtl = computed(() => ['ar'].includes(locale.value))

  return { isRtl }
}

export function useToLogin() {
  const router = useRouter()
  const localePath = useLocalePath()
  const user = useUserStore()

  function toLogin() {
    if (!user.isLogin) {
      if (inUniAppOrApp) {
        nativeGoLogin()
      }
      else {
        router.push(useBackUrl(localePath('/log-in')))
      }
    }
    return user.isLogin
  }

  return { toLogin }
}
